import { IsISO8601, IsString, ValidateIf } from 'class-validator';

export class SensorDto {
  @IsString()
  type!: string;

  @IsISO8601()
  started!: string;

  @IsISO8601()
  @ValidateIf((_, value) => value !== null)
  ended!: string | null;

  @IsString()
  lifetime!: string;
}
